import React from 'react';
import FetchOptionsSelect from "./FetshOptionsSelect";
import {GetShippingAddresses} from "../../api/shipping-addresses/getShippingAddresss";
import {useTranslation} from "react-i18next";

const ShippingAddressSelect = ({onChange, defaultFetchOptionIds, office, ...props}) => {

    const { t } = useTranslation();
    const formatProgramOptions = (response) => {
        return response.data.map(fetchOption => ({
            value: fetchOption.id,
            label: fetchOption.name
        }))
    }
    return <FetchOptionsSelect
        onChange={onChange}
        fetchOptionsFunction={GetShippingAddresses}
        fetchOptionsFilterParams={office ? { limit: -1, offset: 0, office_ids: office } : { limit: -1, offset: 0 }}
        loadingPlaceholder={t("Loading Shipping Addresses...")}
        placeholderText={t("Select Shipping Address")}
        defaultFetchOptionIds={defaultFetchOptionIds}
        formatFetchOptionsFunction={formatProgramOptions}
        {...props}
    />

};

export default ShippingAddressSelect;
